import { localized } from "@utils/groq";
import { client } from "@utils/sanity-client";
import { CloudinaryAsset, CLOUDINARY_ASSET_PROJECTION } from "./cloudinary-asset.model";
import { Sanity } from "@models/sanity.model";
import createPaths from "@utils/next/createPaths";

export const InstructorType = "instructor";

export interface Instructor extends Sanity.Page {
  routing_media: CloudinaryAsset;
  hero_media: CloudinaryAsset[];
  body: Sanity.PortableText;
  quote: string;
  social: Sanity.Social;
  tag_eyebrow: string;
  tags: string[];
}

export const INSTRUCTOR_PROJECTION = `{
  _id,
  _type,
  seo,
  slug,
  title,
  body,
  quote,
  social,
  tag_eyebrow,
  tags,
  hero_media[] ${CLOUDINARY_ASSET_PROJECTION}
}`;

export const getInstructorsPaths = async () => {
  const pages = await getInstructors();
  return createPaths(pages);
};

export const getInstructors = async (): Promise<Instructor[]> => {
  return await client.fetch(
    `*[_type == '${InstructorType}' && ${localized}] ${INSTRUCTOR_PROJECTION}`
  );
};

export const getInstructor = async (slug: string): Promise<Instructor> => {
  return await client.fetch(
    `*[_type == '${InstructorType}' && ${localized} && slug.current == $slug][0] ${INSTRUCTOR_PROJECTION}`,
    { slug }
  );
};
